import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  dashboard: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    flexWrap: "wrap",
  },
  rowDashboard: {
    display: "flex",
    padding: "10px",
    width: "100%",
    height: "100%",
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  movementChart: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: "50%",
  },
  mainContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "stretch",
  },
  marker: {
    cursor: "pointer",
    width: "50px",
    height: "80px",
    top: "-80px",
    left: "-25px",
    position: "relative",
  },
  tableContainer: {
    width: "70%",
  },
  mapContainer: {
    width: "28%",
  },
  textExpanded: {
    marginBottom: "10px",
  },
  divButtons: {
    display: "flex",
    justifyContent: "center",
  },
  actionButton: {
    margin: "10px",
  },
  cardActionArea: {
    display: "flex",
  },
  dialog: {
    fontSize: 20,
  },
  cardMedia: {
    height: "auto",
    width: "auto",
    maxWidth: "250px",
    maxHeight: "250px",
    display: "flex",
  },
  cellStyle: {
    width: "20vh",
    maxWidth: "20vh",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0px",
    padding: "0px",
  },
  headerStyle: {
    width: "20vh",
    maxWidth: "20vh",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0px",
    padding: "0px",
  },
  container: {
    display: "flex",
    justifyContent: "space-around",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "3px solid #b3b1b1",
    borderRadius: "7px",
    padding: "10px",
  },
  contact: {
    display: "flex",
    flexDirection: "column",
  },
  noContact: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "3px solid #b3b1b1",
    borderRadius: "7px",
    padding: "10px",
    justifyContent: "center",
  },
}));

export default style;
